import { render, staticRenderFns } from "./LoadSapOld.vue?vue&type=template&id=80828f8c"
import script from "./LoadSapOld.vue?vue&type=script&lang=js"
export * from "./LoadSapOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports